<template lang="pug">
  file-loader(
    @onFileLoad="onFileLoad"
    @onDragOver="fileDragOver = $event"
  )
    slot(:fileDragOver="fileDragOver")
</template>

<script>
export default {
  components: {
    fileLoader: () => import('@/components/global/FileLoader.vue')
  },
  data: () => ({
    fileDragOver: false,
  }),
  methods: {
    onFileLoad(file) {
      if (/\.vtt$/.test(file.name)) {
        this.$emit('on-file-load', file)
      } else {
        this.$notify({text: 'You could only upload *.vtt files', type: 'error'})
      }
    },
  }
}
</script>
